import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, ExternalLink } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";

export default function LegalAdmin() {
  const [v, setV] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/legal").then((r) => setV(r.data.contenu)).catch(() => setV("")); }, []);

  const save = async () => {
    setBusy(true);
    try { await api.put("/admin/legal", { contenu: v }); toast.success("Mention légale enregistrée"); } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };

  return (
    <div className="space-y-6 max-w-4xl">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <h1 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight text-slate-900">Mention légale</h1>
          <p className="text-slate-500 mt-1">Texte de l'ordonnance-loi portant création de l'UAPHARCO (lecture seule pour les visiteurs).</p>
        </div>
        <Link to="/mention-legale" target="_blank" className="inline-flex items-center gap-1 text-sm font-semibold text-emerald-800"><ExternalLink className="h-4 w-4" /> Voir la page publique</Link>
      </div>
      {v === null ? <Loader2 className="h-8 w-8 animate-spin text-emerald-700" /> : (
        <div className="rounded-2xl border border-emerald-900/10 bg-white p-6 space-y-4">
          <Textarea rows={22} data-testid="legal-admin-textarea" value={v} onChange={(e) => setV(e.target.value)} placeholder="Collez ici le texte de l'ordonnance-loi…" className="leading-relaxed" />
          <Button onClick={save} disabled={busy} className="rounded-full" data-testid="legal-admin-save">{busy && <Loader2 className="h-4 w-4 animate-spin mr-2" />}Enregistrer</Button>
        </div>
      )}
    </div>
  );
}
